import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  QueryList,
  ViewChild,
  ViewChildren
} from '@angular/core';
import {ProdutoService} from "../../services/produto.service";
import {ItemPedido} from "../objetos/ItemPedido";
import {ConstantsService} from "../../fidelidade/ConstantsService";
import {AdicionaisCustomizadosComponent} from "../adicionais-customizados/adicionais-customizados.component";
import {SiteCampoAdicionalComponent} from "../site-campo-adicional/site-campo-adicional.component";
import {ActivatedRoute} from "@angular/router";

@Component({
  selector: 'app-tela-adicionar-produto-pdv',
  templateUrl: './tela-adicionar-produto-pdv.component.html',
  styleUrls: ['./tela-adicionar-produto-pdv.component.scss']
})
export class TelaAdicionarProdutoPdvComponent implements OnInit {
  @ViewChild('adicionaisCustomizados', { static: false }) adicionaisCustomizados: AdicionaisCustomizadosComponent;
  @ViewChildren('adicionalComponent') ctrlAdicionais: QueryList<SiteCampoAdicionalComponent>;

  @Output() onAdicionou = new EventEmitter();
  @Output() onAtualizou = new EventEmitter();
  @Output() onCancelouAdicionar = new EventEmitter();

  @Input() editandoItemMesa = false;
  @Input() buscarNoServer = false;

  pedido: any = {};
  loading = false;
  mensagemErro: any = '';

  produtos = [];
  produtosFiltrados = [];
  categorias = [];
  categoriaSelecionada: any;

  indice: number;
  editando: boolean;
  produtoSelecionado: any;

  itemPedido: any = {};
  tipoDeCardapio: any = 'ADMIN';

  buscaTermo = '';
  timerBusca: any;

  constructor(
    private produtoService: ProdutoService,
    private constantsService: ConstantsService,
    private activatedRoute: ActivatedRoute
  ) {}

  ngOnInit() {
    this.loading = true;
    this.activatedRoute.queryParams.subscribe(queryParams => {
      const idMesa = queryParams.idm;
      if (idMesa) this.tipoDeCardapio = 'MESA';

      this.produtoService.listeAhVenda(this.tipoDeCardapio).then((resposta: any) => {
        if (resposta.brindes && resposta.brindes.length)
          resposta.produtos.push(...resposta.brindes);

        this.produtos = resposta.produtos;
        this.constantsService.produtosLoja = resposta.produtos;

        this.extrairCategorias();
        this.loading = false;

        // Seleciona a primeira categoria por padrão
        if (this.categorias.length > 0) {
          this.selecionarCategoria(this.categorias[0]);
        } else {
          this.produtosFiltrados = this.produtos;
        }
      });
    });
  }

  extrairCategorias() {
    const catsMap = new Map();
    this.produtos.forEach(p => {
      if (p.categoria) {
        if (!catsMap.has(p.categoria.id)) {
          catsMap.set(p.categoria.id, p.categoria);
        }
      } else {
        // Categoria "Sem Categoria" ou "Outros" se necessário
      }
    });

    this.categorias = Array.from(catsMap.values()).sort((a, b) => a.posicao - b.posicao);
  }

  selecionarCategoria(categoria: any) {
    this.categoriaSelecionada = categoria;
    this.filtrarProdutos();
  }

  filtrarProdutos() {
    if (this.buscarNoServer && this.buscaTermo && this.buscaTermo.length >= 3) {
        this.filtreNoServer(this.buscaTermo);
        return;
    }

    let lista = this.produtos;

    // Filtro por Categoria
    if (this.categoriaSelecionada) {
      lista = lista.filter(p => p.categoria && p.categoria.id === this.categoriaSelecionada.id);
    }

    // Filtro por Busca Local
    if (this.buscaTermo && this.buscaTermo.length > 0) {
      const termo = this.buscaTermo.toLowerCase();
      lista = lista.filter(p =>
        (p.nome && p.nome.toLowerCase().includes(termo)) ||
        (p.codigoPdv && p.codigoPdv.toLowerCase().includes(termo))
      );
    }

    this.produtosFiltrados = lista;
  }

  filtreNoServer(value) {
    if (this.loading) return;
    if (this.timerBusca) clearTimeout(this.timerBusca);

    this.timerBusca = setTimeout(() => {
      this.loading = true;
      this.produtoService.listeAhVenda(this.tipoDeCardapio, value).then((resposta: any) => {
        this.produtos = resposta.produtos; // Atualiza a lista base com o resultado da busca
        this.extrairCategorias(); // Re-extrai categorias baseadas no resultado? Talvez não seja ideal, mas ok para busca global
        this.loading = false;

        // Aplica filtro de categoria se tiver selecionada (embora busca server geralmente traga tudo misturado)
        // Para simplificar, na busca server, vamos mostrar tudo que veio
        this.produtosFiltrados = this.produtos;
      });
    }, 750);
  }

  onBuscaChange(termo: string) {
    this.buscaTermo = termo;
    this.filtrarProdutos();
  }

  novoItem() {
    this.editando = null;
    delete this.indice;
    this.itemPedido = {
      qtde: 1,
      adicionais: {},
      observacao: ''
    };
    this.produtoSelecionado = null;
  }

  editeItem(indice: number, itemPedido: any) {
    this.produtoSelecionado = this.produtos.find(produto => produto.id === itemPedido.produto.id);
    if (this.produtoSelecionado) {
      this.indice = indice;
      this.editando = true;

      itemPedido.calculePosicaoAdicionais(this.produtoSelecionado.camposAdicionais);
      this.itemPedido = Object.assign(new ItemPedido(itemPedido.produto, itemPedido.qtde, itemPedido.observacao), itemPedido);

      setTimeout(() => {
        if (this.adicionaisCustomizados)
          this.adicionaisCustomizados.setValoresEdicao();

        if (this.itemPedido.produtoTamanho)
          this.onAlterouTamanho(this.itemPedido.produtoTamanho);
      }, 0);
    }
  }

  selecionarProduto(produto: any) {
    this.produtoSelecionado = produto;
    let qtde = this.produtoSelecionado.valorInicial || 1;
    this.itemPedido = new ItemPedido(this.produtoSelecionado, qtde, '');

    const temAdicional: boolean = this.produtoSelecionado.camposAdicionais.length > 0 ||
      (this.produtoSelecionado.tamanhos && this.produtoSelecionado.tamanhos.length);

    const selecionaPeso: boolean = this.exibirUnidade(produto);

    if (temAdicional || selecionaPeso) {
      if (temAdicional)
        this.itemPedido.calculePosicaoAdicionais(this.produtoSelecionado.camposAdicionais);
    } else {
      // Se não tem adicionais, adiciona direto? O usuário disse "pode manter botao selecionar e add quando tem adicionais"
      // Vou manter o fluxo de abrir detalhes para confirmar quantidade/obs
    }

    window.scrollTo(0, 0);
  }

  cancelarSelecao() {
    this.produtoSelecionado = null;
    this.editando = false;
    this.onCancelouAdicionar.emit({});
  }

  adicionarProduto() {
    this.itemPedido.atualizeTotal();
    if (this.valideAdicionais()) {
      this.itemPedido.produto = this.produtoSelecionado;
      this.onAdicionou.emit(this.itemPedido);
      this.produtoSelecionado = null; // Volta para lista
    }
  }

  atualizeProduto() {
    this.itemPedido.atualizeTotal();
    if (this.valideAdicionais()) {
      this.onAtualizou.emit({ indice: this.indice, item: this.itemPedido });
      this.produtoSelecionado = null; // Volta para lista
      this.editando = false;
    }
  }

  // --- Validações e Helpers (Copiados do original) ---

  private valideAdicionais() {
    delete this.mensagemErro;
    if (this.adicionaisCustomizados) {
      let validos = this.adicionaisCustomizados.valideCampos();
      if (!validos) {
        this.mensagemErro = 'Verifique os adicionais obrigatórios';
        return false;
      }
    }

    if (this.itemPedido.desconto && this.itemPedido.desconto > this.itemPedido.total) {
      this.mensagemErro = `Valor máximo do desconto é R$ ${this.itemPedido.total}`;
      return false;
    }

    if (this.informouAdicionaisObrigatorios()) {
      return true;
    } else {
      this.mensagemErro = 'Verifique os adicionais obrigatórios';
      return false;
    }
  }

  private informouAdicionaisObrigatorios() {
    if (!this.produtoSelecionado.camposAdicionais || this.produtoSelecionado.camposAdicionais.length === 0) return true;

    let valido = true;
    let itemPedido = new ItemPedido(this.produtoSelecionado, this.itemPedido.qtde, null);
    itemPedido.adicionais = this.itemPedido.adicionais;

    for (let campoAdicional of this.produtoSelecionado.camposAdicionais) {
      if (!itemPedido.valideCampoAdicional(campoAdicional)) {
        valido = false;
        break;
      }
    }

    // Validação de sabores... (simplificado, mas mantendo lógica se necessário)
    return valido;
  }

  exibirUnidade(produto) {
    return produto && produto.tipoDeVenda && produto.tipoDeVenda === 'Peso';
  }

  obtenhaFormato() {
    if (!this.produtoSelecionado || !this.produtoSelecionado.unidadeMedida)
      return '#####';
    return String(`0.00 ${this.produtoSelecionado.unidadeMedida.sigla}`);
  }

  obtenhaIncremento() {
    if (!this.produtoSelecionado || !this.produtoSelecionado.incremento)
      return 1;
    return this.produtoSelecionado.incremento;
  }

  onAlterouTamanho(produtoTamanho: any) {
    if (this.ctrlAdicionais) {
      this.ctrlAdicionais.forEach((ctlAdicioanais) => {
        ctlAdicioanais.alterouTamanho(produtoTamanho);
      });
    }
  }

  escolheuNovaOpcao(opcao: any) {
    if (this.ctrlAdicionais) {
      this.ctrlAdicionais.forEach((ctlAdicioanal: SiteCampoAdicionalComponent) => {
        ctlAdicioanal.exibaOuEscondaOpcaoQueDepende(opcao);
      });
    }
  }

  desmarcouNovaOpcao(opcao: any) {
    if (this.ctrlAdicionais) {
      this.ctrlAdicionais.forEach((ctlAdicioanal: SiteCampoAdicionalComponent) => {
        ctlAdicioanal.desmarcouOpcaoQueDepende(opcao);
      });
    }
  }
}
